/**
 * Resolve an account's IANA time zone from the auth metadata.
 *
 * `/auth/token/metadata` carries `timeZone` on `currentAccount` and on
 * every entry of `accounts`, so a DS editing a child account's record
 * can name that child's zone rather than its own. Falls back to the
 * backend's own default when the account is unknown or its zone was
 * never set.
 */
import { DEFAULT_ACCOUNT_TIME_ZONE } from '@shared/lib/zonedDay';

export const getAccountTimeZone = (metadata, accountUuid) => {
  const { currentAccount, accounts } = metadata || {};

  if (!accountUuid || accountUuid === currentAccount?.uuid) {
    return currentAccount?.timeZone || DEFAULT_ACCOUNT_TIME_ZONE;
  }

  const account = (accounts || []).find(a => a.uuid === accountUuid);
  return account?.timeZone || currentAccount?.timeZone || DEFAULT_ACCOUNT_TIME_ZONE;
};
